import { constants } from '@config';

module.exports = function (S) {
  const addSvgElementFromJson = S.addSvgElementFromJson;
  const canvas = S.canvas;

  const NS = svgedit.NS;

  // Default enable for web, disabled for mobile
  let isEnabled = false;
  let isSafeAreaEnabled = false;
  let keepVisible = false;

  const innerBox = {};
  let rcr;
  let ccr;
  const bleedAreaUuid = 'bleed_area';
  const safeAreaUuid = 'safe_area';
  const firstNumberGuidelineUuid = 'first_number_guideline';

  function createAreaNode (sStroke, sStrokeWidth, sStrokeOpacity, classValue) {
    const node = document.createElementNS(NS.SVG, 'rect');

    svgedit.utilities.assignAttributes(node, {
      stroke: sStroke,
      'stroke-width': sStrokeWidth,
      'stroke-opacity': sStrokeOpacity,
      fill: 'none',
      style: 'pointer-events:none',
      class: classValue
    });

    return node;
  }

  function showSafeArea () {
    const bleedValues = canvas.runExtensions('getBleedValues');

    document.querySelector('.safeAreaGroup')?.remove();

    rcr = $('#svgroot').get(0).getBoundingClientRect();
    ccr = $('#canvasBackground').get(0).getBoundingClientRect();

    const safeAreaStroke = constants.colors.safeArea;
    const safeAreaSize = getSafeAreaSize(bleedValues.units);
    const safeAreaStrokeWidth = 1;
    const safeAreaStrokeOpacity = 1;
    const safeAreaStrokeDasharray = '5, 5';
    const safeAreaYPos = ccr.top - rcr.top + safeAreaSize;
    const safeAreaHeight = ccr.height - (safeAreaSize * 2);
    const safeArea = createAreaNode(safeAreaStroke, safeAreaStrokeWidth, safeAreaStrokeOpacity, safeAreaUuid);
    let safeAreaXPos = ccr.left - rcr.left + safeAreaSize;
    let safeAreaWidth = ccr.width - safeAreaSize * 2;

    if (INKIVE.Helpers.getPrintGuidelinesProject() === constants.printingTypes['wire-o'].id) {
      safeAreaXPos = ccr.left - rcr.left + safeAreaSize * 3;
      safeAreaWidth = ccr.width - safeAreaSize * 4;
    }

    svgedit.utilities.assignAttributes(safeArea, {
      x: safeAreaXPos,
      y: safeAreaYPos,
      width: safeAreaWidth,
      height: safeAreaHeight,
      'stroke-dasharray': safeAreaStrokeDasharray
    });

    // Group element
    const safeAreaGroup = addSvgElementFromJson({
      element: 'g',
      curStyles: false,
      attr: {
        id: 'safeAreaGroup',
        class: 'safeAreaGroup',
        style: 'pointer-events:none;',
        notice: 0
      }
    }, $('#svgpanel').get(0));

    safeAreaGroup.appendChild(safeArea);

    setTimeout(() => initTooltips(safeAreaUuid));
  }

  function initPrintGuideLine () {
    $('.printGuideLineGroup').remove();

    rcr = $('#svgroot').get(0).getBoundingClientRect();
    ccr = $('#canvasBackground').get(0).getBoundingClientRect();

    let bleedStroke = constants.colors.bleedArea;
    let borderStroke = constants.colors.bleedArea;
    let canvasBorderStroke = constants.colors.canvasBleedArea;
    let canvasBorderStrokeWidth = 2;
    let canvasBorderDashArray = '1';
    let bleedStrokeOpacity = 0.2;

    if (INKIVE.Helpers.getPrintGuidelinesProject()) {
      bleedStroke = '#000000';
      borderStroke = constants.colors.printGuideLines;
      canvasBorderStroke = constants.colors.canvasBleedAreaPrinting;
      canvasBorderStrokeWidth = 1;
      canvasBorderDashArray = '5.34 5.34';
      bleedStrokeOpacity = 0.1;
    }

    const bleedValues = canvas.runExtensions('getBleedValues');
    const pxBleedSize = INKIVE.Helpers.convertUnitsToPixels(bleedValues.left, bleedValues.units);
    const bleedStrokeWidth = pxBleedSize * canvas.getZoom();
    const bleedArea = createAreaNode(bleedStroke, bleedStrokeWidth, bleedStrokeOpacity, bleedAreaUuid);

    svgedit.utilities.assignAttributes(bleedArea, {
      x: ccr.left - rcr.left - (bleedStrokeWidth / 2),
      y: ccr.top - rcr.top - (bleedStrokeWidth / 2),
      width: ccr.width + bleedStrokeWidth,
      height: ccr.height + bleedStrokeWidth
    });

    const borderStrokeWidth = 2;
    const borderStrokeOpacity = 0.6;
    const borderXPos = ccr.left - rcr.left - bleedStrokeWidth;
    const borderYPos = ccr.top - rcr.top - bleedStrokeWidth;
    const bleedAreaBorder = createAreaNode(borderStroke, borderStrokeWidth, borderStrokeOpacity, `${bleedAreaUuid}-border`);

    svgedit.utilities.assignAttributes(bleedAreaBorder, {
      x: borderXPos,
      y: borderYPos,
      width: ccr.width + (bleedStrokeWidth * 2),
      height: ccr.height + (bleedStrokeWidth * 2)
    });

    const canvasBorderStrokeOpacity = 1;
    const canvasBorder = createAreaNode(canvasBorderStroke, canvasBorderStrokeWidth, canvasBorderStrokeOpacity, 'canvas-border');

    svgedit.utilities.assignAttributes(canvasBorder, {
      x: ccr.left - rcr.left,
      y: ccr.top - rcr.top,
      width: ccr.width,
      height: ccr.height,
      'stroke-dasharray': canvasBorderDashArray
    });

    // Group element
    const printGuideLineGroup = addSvgElementFromJson({
      element: 'g',
      curStyles: false,
      attr: {
        id: 'printGuideLineGroup',
        class: 'printGuideLineGroup',
        style: 'pointer-events:none;display:none',
        notice: 0
      }
    }, $('#svgpanel').get(0));

    printGuideLineGroup.appendChild(bleedArea);
    printGuideLineGroup.appendChild(bleedAreaBorder);
    printGuideLineGroup.appendChild(canvasBorder);

    setTimeout(() => initTooltips(bleedAreaUuid));
  }

  function createBigTooltip (uuid, title, body, onClose) {
    const div = document.createElement('div');
    div.innerHTML = `<div id=${uuid}_tooltip class="big-tooltip bleed-area" style="position: absolute; z-index: 1070; margin-top: -3px; padding: 5px 0;">\
      <div style="padding: 20px 25px; color: #1f2631; background-color: #fff; border-radius: 12px; border: 1px solid #dde1e5; box-shadow: 0 0 8px rgba(0, 0, 0, 0.16); position: relative;">\
        <h1 style="font-weight: bold; font-size: 16px; line-height: 24px; margin: 0 0 8px;">${title}</h1>\
        <p style="font-weight: 400; font-size: 14px; line-height: 20px;">${body}</p>\
        <i class="desygner-icon-close" style="position: absolute; color: #8fa1b3; top: 25px; right: 25px; cursor: pointer"></i>\
      </div>\
      <div class="tooltip-arrow" style="position: absolute; left: -9px; top: 25%; width: 0; height: 0; border-style: solid; border-width: 10px 0 10px 10px; border-color: transparent transparent transparent #fff;"></div>\
    </div>`;

    const bigTooltip = div.firstChild;
    const closeBtn = bigTooltip.querySelector('.desygner-icon-close');

    closeBtn.addEventListener('click', onClose);

    return bigTooltip;
  }

  function initTooltips (type) {
    if (INKIVE.C.IS_MOBILE ||
      localStorage.getItem(`tooltip:${type}:hide`) ||
      document.querySelector(`#${type}_tooltip`) ||
      document.querySelector('body').classList.contains('ux-dialog-open')
    ) {
      return;
    }

    const area = document.querySelector(`.${type}`);

    if (!area) return;

    const tooltip = createBigTooltip(
      type,
      INKIVE.TranslateHelper.translate(`bleed.${type}`),
      INKIVE.TranslateHelper.translate(`bleed.${type}_message`),
      () => {
        localStorage.setItem(`tooltip:${type}:hide`, 'true');
        tooltip?.remove();
      });
    document.querySelector('body').append(tooltip);
    setTooltipPosition(area, tooltip, type);
  }

  function setTooltipPosition (externalBox, tooltip, type) {
    if (!externalBox) return;
    const width = 350;
    tooltip.style.width = `${width}px`;
    const tooltipRect = tooltip.getBoundingClientRect();
    const externalBoxRect = externalBox.getBoundingClientRect();
    const arrow = tooltip.querySelector('.tooltip-arrow');
    let right = externalBoxRect.right + arrow.getBoundingClientRect().width;
    let top;

    switch (type) {
      case bleedAreaUuid:
        top = externalBoxRect.y;
        break;
      case safeAreaUuid:
        top = externalBoxRect.y + externalBoxRect.height - tooltipRect.height;
        break;
      case firstNumberGuidelineUuid:
        arrow.style.transform = 'rotate(180deg)';
        arrow.style.right = `${width}px`;
        top = externalBoxRect.y - parseInt(arrow.style.borderTop);
        right = externalBoxRect.x + externalBoxRect.width + arrow.getBoundingClientRect().width - 2;
        break;
    }
    arrow.style.transform = 'rotate(180deg)';
    tooltip.style.left = `${right}px`;
    tooltip.style.top = `${top}px`;
  }

  function flashPrintGuideLine () {
    initPrintGuideLine();
    const $printGuideLineGroup = $('.printGuideLineGroup');

    if (keepVisible) {
      $printGuideLineGroup.show();
    } else {
      $printGuideLineGroup.fadeIn(450).fadeOut(350).fadeIn(350).fadeOut(350);
    }

    INKIVE.Helpers.getPrintGuidelinesProject() === constants.printingTypes.mug.id && printingGuides();
  }

  function hidePrintGuideLine () {
    document.querySelector('.printGuideLineGroup')?.remove();
    document.querySelectorAll('.big-tooltip.bleed-area').forEach(node => node.remove());
    INKIVE.Helpers.getPrintGuidelinesProject() === constants.printingTypes.mug.id && printingGuides();
  }

  /**
   * Shows red corner on the drawing area
   */
  function showPrintGuideLine (selected) {
    if (!isEnabled) {
      return;
    }

    const $printGuideLineGroup = $('.printGuideLineGroup');

    if ($printGuideLineGroup.length) {
      const selectorBb = $('#selectorParentGroup').find('path')[0].getBoundingClientRect();
      const selector = {
        top: selectorBb.top - rcr.top,
        right: selectorBb.right - rcr.left,
        bottom: selectorBb.bottom - rcr.top,
        left: selectorBb.left - rcr.left
      };

      const isOutOfWorkingArea =
        selector.top < innerBox.top ||
        selector.right > innerBox.right ||
        selector.bottom > innerBox.bottom ||
        selector.left < innerBox.left;

      if (isOutOfWorkingArea) {
        for (let i = 0; i < selected.length; i++) {
          if (isValidElem(selected[i])) {
            $printGuideLineGroup.show();
            canvas.call('advice.show', 'crop');

            if ($printGuideLineGroup.attr('notice') !== 1) {
              $printGuideLineGroup.attr('notice', 1);
            }

            break;
          }
        }
      } else {
        $printGuideLineGroup.hide();
      }
    }
  }

  function isValidElem (elem) {
    return elem && elem.id;
  }

  function getSafeAreaSize (units) {
    let safeAreaSize = 15;

    switch (units) {
      case 'in':
        safeAreaSize = 0.15;
        break;
      case 'cm':
        safeAreaSize = 0.4;
        break;
      case 'mm':
        safeAreaSize = 4;
        break;
    }
    return INKIVE.Helpers.convertUnitsToPixels(safeAreaSize, units) * canvas.getZoom();
  }

  function printingGuides () {
    if (!INKIVE.Helpers.getPrintGuidelinesProject()) {
      return;
    }

    const lines = [];
    const numberGuidelines = [];
    let printingGuidesGroup = document.querySelector('.printingGuidesGroup');

    if (!printingGuidesGroup) {
      const resizeButton = document.querySelector('[data-action="resize"]');
      if (resizeButton) resizeButton.classList.add('hidden');

      printingGuidesGroup = addSvgElementFromJson({
        element: 'g',
        curStyles: false,
        attr: {
          id: 'printingGuidesGroup',
          class: 'printingGuidesGroup',
          style: 'pointer-events:none;',
          notice: 0
        }
      }, document.querySelector('#svgpanel'));
    }

    const horizontalFolding = INKIVE.C.PRINTING_TYPE.horizontal_folding;
    const canvasBg = document.querySelector('#canvasBackground');
    const canvasTop = canvasBg.getAttribute('y') * canvas.getZoom();
    const canvasWidth = canvasBg.getAttribute('width') * canvas.getZoom();
    const canvasLeft = canvasBg.getAttribute('x') * canvas.getZoom();
    const canvasHeight = canvasBg.getAttribute('height') * canvas.getZoom();
    const linePosition = horizontalFolding ? canvasTop : canvasLeft;
    const lineSize = horizontalFolding ? canvasHeight : canvasWidth;
    const isFirstPage = INKIVE.PageFactory.getCurrentPageNumber() === 1;

    const createSeparator = function (position, strokeColor = constants.colors.printGuideLines) {
      const line = document.createElementNS(NS.SVG, 'line');

      const attributes = {
        stroke: strokeColor,
        'stroke-dasharray': '12 12',
        'stroke-width': '0.2%'
      };
      attributes[horizontalFolding ? 'y1' : 'x1'] = position;
      attributes[horizontalFolding ? 'y2' : 'x2'] = position;
      attributes[horizontalFolding ? 'x1' : 'y1'] = horizontalFolding ? canvasLeft : canvasTop;
      attributes[horizontalFolding ? 'x2' : 'y2'] = horizontalFolding ? canvasLeft + canvasWidth : canvasTop + canvasHeight;

      svgedit.utilities.assignAttributes(line, attributes);

      return line;
    };

    const createNumberGuidelines = function (caption, position, sections) {
      const number = document.createElementNS(NS.SVG, 'text');
      const fontSize = 56 * canvas.getZoom();
      const x = horizontalFolding
        ? canvasLeft + canvasWidth / 2 - fontSize / 2
        : canvasLeft + canvasWidth / (sections * 2) * (position * 2 - 1) - fontSize / 2;
      const y = horizontalFolding
        ? canvasTop + canvasHeight / (sections * 2) * (position * 2 - 1) + fontSize / 2
        : canvasTop + canvasHeight / 2 + fontSize / 2;
      const attributes = {
        fill: constants.colors.numberGuidelines,
        opacity: 0.05,
        'font-weight': 700,
        'font-size': fontSize,
        class: position === 1 ? firstNumberGuidelineUuid : '',
        x,
        y
      };

      svgedit.utilities.assignAttributes(number, attributes);
      number.innerHTML = caption;

      return number;
    };

    while (printingGuidesGroup.firstChild) {
      printingGuidesGroup.removeChild(printingGuidesGroup.lastChild);
    }

    switch (INKIVE.Helpers.getPrintGuidelinesProject()) {
      case constants.printingTypes.bifold.id:
        lines.push(createSeparator(lineSize / 2 + linePosition));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 4 : 2, 1, 2));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 1 : 3, 2, 2));
        break;

      case constants.printingTypes.trifold.id:
        lines.push(createSeparator(lineSize / 3 + linePosition));
        lines.push(createSeparator(lineSize / 3 * 2 + linePosition));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 2 : 3, 1, 3));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 6 : 4, 2, 3));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 1 : 5, 3, 3));
        break;

      case constants.printingTypes.accordion.id:
        lines.push(createSeparator(lineSize / 4 + linePosition));
        lines.push(createSeparator(lineSize / 4 * 3 + linePosition));
        lines.push(createSeparator(lineSize / 4 * 2 + linePosition));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 6 : 2, 1, 4));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 7 : 3, 2, 4));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 8 : 4, 3, 4));
        numberGuidelines.push(createNumberGuidelines(isFirstPage ? 1 : 5, 4, 4));
        break;

      case constants.printingTypes.mug.id:
        lines.push(createSeparator(canvasWidth / 4 + canvasLeft, constants.colors.mugGuideline));
        lines.push(createSeparator(canvasWidth / 4 * 3 + canvasLeft, constants.colors.mugGuideline));
        lines.push(createSeparator(canvasWidth / 4 * 2 + canvasLeft, constants.colors.mugGuideline));
        addMugIcons(printingGuidesGroup, lines);
        break;
    }

    lines.forEach((line) => {
      printingGuidesGroup.prepend(line);
    });
    numberGuidelines.forEach((number) => {
      printingGuidesGroup.append(number);
    });

    setTimeout(() => initTooltips(firstNumberGuidelineUuid));
  }

  function addMugIcons (printingGuidesGroup, lines) {
    if (!document.querySelector('#mug---left')) {
      setTimeout(() => addMugIcons(printingGuidesGroup, lines), 100);
      return;
    }

    if (document.querySelector('.mug-guideline-icon') || canvas.getZoom() < 0.2) {
      return;
    }

    lines.forEach((line, i) => {
      let mugId;
      let position;

      switch (i) {
        case 0:
          mugId = 'left';
          position = -5;
          break;
        case 1:
          mugId = 'right';
          position = 2;
          break;
        case 2:
          mugId = 'center';
          position = -2;
          break;
      }

      const icon = document.querySelector(`#mug---${mugId}`).firstChild.cloneNode();
      const bleedValues = canvas.runExtensions('getBleedValues');
      const top = line.getAttribute('y1') - (45 + (bleedValues.active
        ? INKIVE.Helpers.convertUnitsToPixels(bleedValues.top, bleedValues.units) * canvas.getZoom()
        : 0));

      svgedit.utilities.assignAttributes(icon, {
        stroke: constants.colors.mugGuideline,
        'stroke-width': 3,
        fill: 'transparent'
      });
      printingGuidesGroup.append(icon);
      position += line.getAttribute('x1') - icon.getBBox().width / 2;
      const g = addSvgElementFromJson({
        element: 'g',
        curStyles: false,
        attr: {
          style: `transform: translate(${position}px, ${top}px)`,
          class: 'mug-guideline-icon'
        }
      }, printingGuidesGroup);

      g.append(icon);
      printingGuidesGroup.appendChild(g);
    });
  }

  return {

    // The main (left) mouse button is held down on the canvas area
    mouseDown: function () {
      if (!isEnabled || keepVisible) {
        return;
      }

      const selected = canvas.getSelectedElems();
      canvas.getMode() === 'select' && ((selected.length === 1 && isValidElem(selected[0])) || selected.length > 1) && initPrintGuideLine();
    },

    // The main (left) mouse button is released (anywhere)
    mouseUp: function () {
      if (!isEnabled || keepVisible) {
        return;
      }

      hidePrintGuideLine();
    },

    mouseMove: function () {
      if (!isEnabled || keepVisible) {
        return;
      }

      canvas.getMode() === 'select' && showPrintGuideLine(canvas.getSelectedElems());
    },

    enableGuideLine: function (opts) {
      isEnabled = true;
      keepVisible = opts && opts.keepVisible;
      flashPrintGuideLine();
    },

    showSafeArea: function () {
      showSafeArea();
      isSafeAreaEnabled = true;
    },

    hideSafeArea: function () {
      isSafeAreaEnabled = false;
      document.querySelector('.safeAreaGroup')?.remove();
      document.querySelector(`#${safeAreaUuid}`)?.remove();
    },

    disableGuideLine: function () {
      hidePrintGuideLine();
      keepVisible = false;
      isEnabled = false;
    },

    isGuideLineEnabled: function () {
      return isEnabled;
    },

    zoomChanged: function () {
      hidePrintGuideLine();
      printingGuides();
      isEnabled && flashPrintGuideLine();
      isSafeAreaEnabled && showSafeArea();
    }
  };
};
